var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('e-scrollable-search-filter-page', {
    ref: "page",
    attrs: {
      "service": _vm.service
    },
    on: {
      "enableSpinner": function enableSpinner($event) {
        return _vm.enableSpinner();
      },
      "disableSpinner": function disableSpinner($event) {
        return _vm.disableSpinner();
      }
    },
    scopedSlots: _vm._u([{
      key: "header-controls",
      fn: function fn(_ref) {
        var created = _ref.created,
            searchText = _ref.searchText,
            page = _ref.page;
        return [_c('b-button-toolbar', {
          staticClass: "float-right",
          attrs: {
            "key-nav": ""
          }
        }, [_c('b-button-group', {
          staticClass: "mx-1"
        }, [_c('b-button', {
          staticClass: "pl-2 pr-2",
          attrs: {
            "type": "button",
            "size": "sm",
            "variant": "secondary"
          },
          on: {
            "click": function click($event) {
              return _vm.syncZipCodes(searchText, page);
            }
          }
        }, [_c('b-icon', {
          attrs: {
            "icon": "arrow-left-right"
          }
        }), _vm._v(" " + _vm._s(_vm.$t('controls.sync')) + " ")], 1)], 1)], 1)];
      }
    }, {
      key: "spinner",
      fn: function fn() {
        return [_vm.loading ? _c('b-spinner', {
          staticClass: "spinner",
          attrs: {
            "label": "Loading..."
          }
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "entity-content",
      fn: function fn(context) {
        return [_c('detail-view', {
          attrs: {
            "id": context.id,
            "link": context.entity._links.self.href
          },
          on: {
            "enableSpinner": function enableSpinner($event) {
              return _vm.enableSpinner();
            },
            "disableSpinner": function disableSpinner($event) {
              return _vm.disableSpinner();
            }
          }
        })];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }